import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { motion } from 'motion/react'

import { primaryShowElement } from 'src/animations/Animations'
import { CustomButton, Icon } from 'src/components/ui'

import styles from './StatusPage.module.scss'

const BottleCreated = ({ status }: { status: 'confirmation' | 'error' }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <main className={styles.wrapper}>
      <div className={styles.wrapper_header}>
        <motion.span {...primaryShowElement(0.5)}>
          <Icon name={status === 'confirmation' ? 'successfully' : 'error'} />
        </motion.span>

        <motion.h1 {...primaryShowElement(1)}>{t(`status_page.${status}.title`)}</motion.h1>
        <motion.p {...primaryShowElement(1.5)}>{t(`status_page.${status}.subtitle`)}</motion.p>
      </div>

      <div className={styles.wrapper_tabs}>
        {status === 'confirmation' && (
          <motion.div {...primaryShowElement(2.5)}>
            <CustomButton onClick={() => navigate('/bottles?mode=my')} variant='outlined' color='white'>
              {t('status_page.show_bottles')}
            </CustomButton>
          </motion.div>
        )}

        <motion.div {...primaryShowElement(2)}>
          <CustomButton
            onClick={() => navigate(`${status === 'confirmation' ? '/' : '/create-bottle/step-4'}`)}
            variant='contained'
            color='white'
          >
            {t(`status_page.${status}.link_text`)}
          </CustomButton>
        </motion.div>
      </div>
    </main>
  )
}

export default BottleCreated
